import { Configuration } from '../API';

export const apiConfig = new Configuration({
  basePath: process.env.REACT_APP_API_BASE_URL,
  accessToken: 'DUMMY'
});
